<template>
  <ui-container>
    <ui-row align-h="center">
      <ui-col :lg="10">
        <article-list class="event-article-list" v-if="eventName" from="book" :event-name="eventName"></article-list>
      </ui-col>
    </ui-row>
  </ui-container>
</template>
<script>
import ArticleList from '../../components/article/ArticleList.vue'
export default {

  name: 'list',

  data() {
    return {
      eventName: ''
    }
  },
  components: {
    ArticleList
  },
  mounted() {
    this.eventName = this.$route.params.eventName

  }
}

</script>
<style lang="css" scoped>
</style>
